import { render, staticRenderFns } from "./storageRoomList.vue?vue&type=template&id=66127b9d&scoped=true"
import script from "./storageRoomList.vue?vue&type=script&lang=js"
export * from "./storageRoomList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66127b9d",
  null
  
)

export default component.exports